import request from "@/utils/request";
export const queryPage =
  "/icps/system/sign/intelligent/proDispatchLogistics/get_pro_dispatch_list";
export const Download =
  "/icps/system/sign/intelligent/proDispatchLogistics/exception/exportHandle";

/*分页获取物流信息列表*/
export function get_dispatch_logistics_page(data) {
  return request({
    url:
      "/icps/system/sign/intelligent/proDispatchLogistics/get_dispatch_logistics_page",
    method: "post",
    data,
  });
}
/*信息补录*/
export function save_information_collection(data) {
  return request({
    url:
      "/icps/system/sign/intelligent/proDispatchLogistics/save_information_collection",
    method: "post",
    data,
  });
}
/*空票签收*/
export function save_empty_ticket_sign(data) {
  return request({
    url:
      "/icps/system/sign/intelligent/proDispatchLogistics/save_empty_ticket_sign",
    method: "post",
    data,
  });
}
/*退货通知*/
export function handler_operation_notice(data) {
  return request({
    url:
      "/icps/system/sign/intelligent/proDispatchLogistics/operation/handler_operation_notice_return",
    method: "post",
    data,
  });
}
/*修改退货通知备注*/
export function update_remark(data) {
  return request({
    url:
      "/icps/system/sign/intelligent/proDispatchLogistics/operation/update_remark",
    method: "post",
    data,
  });
}
/*操作通知回场过磅*/
export function handler_operation_notice_weighing(data) {
  return request({
    url:
      "/icps/system/sign/intelligent/proDispatchLogistics/operation/handler_operation_notice_weighing",
    method: "post",
    data,
  });
}
/*修改异常管理*/
export function handler_exception(data) {
  return request({
    url:
      "/icps/system/sign/intelligent/proDispatchLogistics/exception/handler_exception",
    method: "post",
    data,
  });
}
/*修改异常管理*/
export function update_exception(data) {
  return request({
    url:
      "/icps/system/sign/intelligent/proDispatchLogistics/exception/update_exception",
    method: "post",
    data,
  });
}
// /*公司质量参数-获取检验列表：检测类别中的混凝土*/
export function qualityDetectiongetList(data) {
  return request({
    url: "/icps/system/sign/basics/qualityDetection/getList",
    method: "post",
    data,
  });
}
// /*操作通知抽检*/
export function handler_operation_notice_check(data) {
  return request({
    url:
      "/icps/system/sign/intelligent/proDispatchLogistics/operation/handler_operation_notice_check",
    method: "post",
    data,
  });
}
// /*获取车辆位置*/
export function get_car_location(data) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/get_car_location",
    method: "post",
    data,
  });
}
// /*获取工程列表*/
export function get_engineering_list(params) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/get_engineering_list",
    method: "get",
    params,
  });
}

// /*调整余料量，调整签收量*/
export function update_adjust_num(data) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/update_adjust_num",
    method: "post",
    data,
  });
}
// /*通知客户*/
export function notice_customer(data) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/notice_customer",
    method: "post",
    data,
  });
}
// /*过磅核对*/
export function get_weighing_check(params) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/get_weighing_check",
    method: "get",
    params,
  });
}
//新增一条模拟数据*/
export function save_fake_erp_data(data) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/save_fake_erp_data",
    method: "post",
    data,
  });
}
//数据来源-直供或代加工选择，我方运输或外协运输，我方泵送或外协泵送*/
export function update_data_type(data) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/update_data_type",
    method: "post",
    data,
  });
}
// /*查看视频*/
export function get_video_path(params) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/get_video_path",
    method: "get",
    params,
  });
}
//小方量运输计算差量*/
export function set_small_quantities_delta(data) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/set_small_quantities_delta",
    method: "post",
    data,
  });
}

//获取车辆排队信息*/
export function get_queue_up_inform(data) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/get_queue_up_inform",
    method: "post",
    data,
  });
}
// 取消车辆排队
export function cancelLineUp(data) {
  return request({
    url: "/icps/system/sign/intelligent/tankerQueueUp/cancel",
    method: "post",
    data,
  });
}
// 强制取消车辆排队
export function forceCancel(data) {
  return request({
    url: "/icps/system/sign/intelligent/tankerQueueUp/forceCancel",
    method: "post",
    data,
  });
}
//后场签收*/
export function WXupdateStatus(data) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/WXupdateStatus",
    method: "post",
    data,
  });
}
/**
 * @Description: 签收2
 * @param {*} data
 * @Author: wangwangwang
 */
export function backManSign(params) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/backManSign",
    method: "get",
    params,
  });
}
//选择泵管使用*/
export function update_pump_line_use(data) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/updatePumpLineUse",
    method: "post",
    data,
  });
}
//电子围栏list*/
export function QueryPageElectronicFence(data) {
  return request({
    url: "/icps/system/sign/cloudSell/engineeringManagement/QueryPageElectronicFence",
    method: "post",
    data,
  });
}
//获取打印司机小票信息*/
export function driverReceipts(data) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/driverReceipts",
    method: "post",
    data,
  });
}
//司机小票发送*/
export function update_confirm_and_data_status(data) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/updateStatus",
    method: "post",
    data,
  });
}
// /*根据计划id获取发料通知列表*/
export function noticeNotice_list(params) {
  return request({
    url: "/icps/system/sign/basics/plan/notice/notice_list",
    method: "get",
    params,
  });
}
// 根据站点查询车*/
export function get_queue_up_inform_by_station(data) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/get_queue_up_inform_by_station",
    method: "post",
    data,
  });
}
// 物流信息弹窗修改*/
export function update_logistics(data) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/update_logistics",
    method: "post",
    data,
  });
}
// 物流信息弹窗修改*/
export function getCarInfo(data) {
  return request({
    // url: "/icps/system/sign/intelligent/proDispatchLogistics/getCarInfo",
    url: "/icps/system/sign/intelligent/proDispatchLogistics/getCarInfoNew",
    method: "post",
    data,
  });
}
// 物流信息弹窗修改*/
export function getOrderInfoByEngineeringId(data) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/getOrderInfoByEngineeringId",
    method: "post",
    data,
  });
}

// 查看车辆的历史物流
export function getLogisticsByCarNo(data) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/getLogisticsByCarNo",
    method: "post",
    data,
  });
}

// 查看物料轨迹
export function getCarPath(data) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/getCarPath",
    method: "post",
    data,
  });
}

// 转料保存
export function handlerExceptionNew(data) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/exception/handler_exception_new",
    method: "post",
    data,
  });
}
// 转料保存 - new
export function saveTransferMaterials(data) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/exception/saveTransferMaterials",
    method: "post",
    data,
  });
}
// 翻料保存
export function saveOverMaterials(data) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/exception/saveOverMaterials",
    method: "post",
    data,
  });
}
// 积鼓或报废保存
export function saveOther(data) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/exception/saveOther",
    method: "post",
    data,
  });
}

// 查看历史物流
export function queryLogisticsListMap(data) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/query_logistics_list_map",
    method: "post",
    data,
  });
}

// 查看站点物料轨迹
export function getLogisticsLine(data) {
  return request({
    url: "/icps/system/sign/intelligent/proDispatchLogistics/getCarPathNew",
    method: "post",
    data,
  });
}
// 查看站点物料轨迹 //更换接口 map
export function getLogisticsLineNew(data) {
  return request({
    url: "/map/outer/logistics/get_logistics_line",
    method: "post",
    data,
  });
}

// 获取星软GPS定位列表
export function XingRuangetLists(data) {
  return request({
    url: "/icps/system/sign/intelligent/positioningData/getLists",
    method: "post",
    data,
  });
}

// 根据车牌号查询列表*/
export function getXinRuanPosition(params) {
  return request({
    url: "/icps/system/sign/intelligent/positioningData/getPosition",
    method: "get",
    params,
  });
}
// 根据车牌号查询列表*/
export function updateNotice(data) {
  return request({
    url: "/icps/system/sign/basics/plan/notice/updateNotice",
    method: "post",
    data,
  });
}

// 生产排程-获取余料翻出记录
export function overNumQueryPage(data) {
  return request({
    url: "/icps/system/sign/intelligent/residueTurnOut/query_page",
    method: "post",
    data,
  });
}

// 生产排程-余料翻出 
export function overNumSave(data) {
  return request({
    url: "/icps/system/sign/intelligent/residueTurnOut/save",
    method: "post",
    data,
  });
}

// 生产调度-保存打印模板id
export function updateTempId(data) {
  return request({
    url: "/icps/system/sign/basics/stationTemplate/updateTempId",
    method: "post",
    data,
  });
}
// 生产调度-余料比例设置查询
export function selectCloutSetting(data) {
  return request({
    url: "/icps/system/sign/basics/plan/selectCloutSetting",
    method: "post",
    data,
  });
}
// 生产调度-余料比例设置修改
export function updateCloutSetting(data) {
  return request({
    url: "/icps/system/sign/basics/plan/updateCloutSetting",
    method: "post",
    data,
  });
}
// 生产调度-新增出场过磅
export function addOutboundTask(data) {
  return request({
    url: "/icps/system/sign/intelligent/OutAndIn/addOutboundTask",
    method: "post",
    data,
  });
}
// 生产调度-新增回场过磅
export function addInboundTask(data) {
  return request({
    url: "/icps/system/sign/intelligent/OutAndIn/addInboundTask",
    method: "post",
    data,
  });
}
/*生产调度打印 */
export function printTicket(params) {
  return request({
    url: '/icps/system/sign/intelligent/logisticsVote/printTicket',
    method: 'get',
    params
  })
}
/*余料处理 --列表查询 */
export function querySurplusLogisticsPage(data) {
  return request({
    url: '/icps/system/sign/intelligent/proDispatchLogistics/exception/querySurplusLogisticsPage',
    method: 'post',
    data
  })
}
/*翻料处理 --查询 */
export function queryHandlePage(data) {
  return request({
    url: '/icps/system/sign/intelligent/residueTurnOut/queryHandlePage',
    method: 'post',
    data
  })
}
/*余料处理 --根据单号查询计划 */
export function getPlanByCode(data) {
  return request({
    url: '/icps/system/sign/intelligent/proDispatchLogistics/exception/getPlanByCode',
    method: 'post',
    data
  })
}
/*余料处理 --取消 */
export function cancelHandle(data) {
  return request({
    url: '/icps/system/sign/intelligent/proDispatchLogistics/exception/cancelHandle',
    method: 'post',
    data
  })
}